import React from 'react';
export default function FlexibleSnowReport({report}) {
    if (!report.conditions) {
        return;
    }
    return (
        <div className={'flexible-snow-report'}>
            {report.updateTime && <p className={'update-time'}>Updated: {report.updateTime}</p>}
            {
                report.conditions.map((conditions) => {
                    let location = conditions.location && conditions.elevation ? conditions.location + ' ' + conditions.elevation : (conditions.location || conditions.elevation);
                    location += conditions.elevation ? 'm' : '';

                    return (
                        <div className={'location-container'}>
                            {location && location !== 'undefined' &&
                                <p className={'location-title'}>{location}</p>
                            }
                            <div className={'row'}>
                                {conditions.weather &&
                                    <div className={'item weather'}>
                                        <p className={'title'}>Today's Outlook</p>
                                        <p className={'value'}>{conditions.weather}</p>
                                    </div>
                                }
                                {conditions.roadStatus &&
                                    <div className={'item road-status'}>
                                        <p className={'title'}>Road Status</p>
                                        <p className={'value'}>{conditions.roadStatus}</p>
                                    </div>
                                }
                                {conditions.visibility &&
                                    <div className={'item'}>
                                        <p className={'subtitle'}>Visibility</p>
                                        <p className={'value'}>{conditions.visibility}</p>
                                    </div>
                                }
                                {conditions.snowQuality &&
                                    <div className={'item'}>
                                        <p className={'subtitle'}>Snow Conditions</p>
                                        <p className={'value'}>{conditions.snowQuality}</p>
                                    </div>
                                }
                                {Number.isFinite(conditions.freezingLevel) &&
                                    <div className={'item'}>
                                        <p className={'subtitle'}>Freezing Level</p>
                                        <p className={'value'}>{conditions.freezingLevel}</p>
                                    </div>
                                }
                                {Number.isFinite(conditions.temperature) &&
                                    <div className={'item'}>
                                        <p className={'subtitle'}>Temperature</p>
                                        <p className={'value'}>{conditions.temperature}°C</p>
                                    </div>
                                }
                                {Number.isFinite(conditions.feelsLike) &&
                                    <div className={'item'}>
                                        <p className={'subtitle'}>Feels Like</p>
                                        <p className={'value'}>{conditions.feelsLike}°C</p>
                                    </div>
                                }
                                {Number.isFinite(conditions.minTemperature) &&
                                    <div className={'item'}>
                                        <p className={'subtitle'}>Min Temp.</p>
                                        <p className={'value'}>{conditions.minTemperature}°C</p>
                                    </div>
                                }
                                {Number.isFinite(conditions.maxTemperature) &&
                                    <div className={'item'}>
                                        <p className={'subtitle'}>Max Temp.</p>
                                        <p className={'value'}>{conditions.maxTemperature}°C</p>
                                    </div>
                                }
                                {conditions.windSpeed &&
                                    <div className={'item'}>
                                        <p className={'subtitle'}>Wind (km/h)</p>
                                        <div className={'wind-wrapper'}>
                                            <p className={'value'}>{getWindString(conditions)}</p>
                                            <WindDirection conditions={conditions}/>
                                        </div>
                                    </div>
                                }
                            </div>
                            {conditions.snowfall?.length > 0 &&
                                <Snowfall conditions={conditions}/>
                            }
                        </div>
                    )
                })
            }
            {
                report.conditions.map((conditions) => (
                    <>
                        {!!conditions.liftsStatus && <LiftStatus lifts={conditions.liftsStatus}/>}
                    </>
                ))
            }
        </div>
    )
}

function Snowfall({conditions}) {
    return (
        <div className={'last-snowfall'}>
            {!conditions.lastSnowfall && <p className={'title'}>Snowfall</p>}
            {!!conditions.lastSnowfall &&
                <div className={'title'}>
                    <p>Last Snowfall: </p>
                    <p>{conditions.lastSnowfall}</p>
                </div>
            }
            <div className={'row'}>
                {conditions.snowfall.map((snowfall) => {
                    const amount = snowfall.amount + (String(snowfall.amount).includes('cm') ? '' : 'cm');
                    return (
                        <div className={'item'} key={snowfall.type}>
                            <p className={'subtitle'}>{snowfall.type}</p>
                            <p className={'value'}>{amount}</p>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

function LiftStatus({lifts}) {
    return (
        <div className='lifts-wrapper location-container'>
            <p className={'location-title'}>Lift Status</p>
            <div className={'lifts'}>
                {lifts.map((lift) => {
                    return (
                        <div className={'lift'}>
                            <p className={'name'}>{lift?.name}</p>
                            <div className={'status-wrapper'}>
                                <p className={'status ' + lift?.status.toLowerCase()}>{lift?.status}</p>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

function WindDirection({conditions}) {
    if (conditions?.windDirection.length <= 2) {
        return <img src={getWindIconUrl(conditions.windDirection)}/>
    } else if (conditions?.windDirection) {
        return <p className={'value wind-direction'}>{conditions.windDirection}</p>
    }
}

function getWindIconUrl(windDirection) {
    return 'https://www.mountainwatch.com/images/wind_' + (windDirection || '') + '.jpg';
}
function getWindString(conditions) {
    if (typeof conditions?.windSpeed === 'string') {
        return conditions.windSpeed.includes(conditions.windDirection) ?
            conditions.windSpeed : conditions.windDirection + ' ' + conditions.windSpeed;
    }
    return conditions?.windSpeed;
}